import { ObjectState } from "@homebound/form-state";
import { useCallback } from "react";
import { LocationPathField } from "src/components/locationPathField/LocationPathField";
import { TakeoffsStoreState } from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerContext";
import { StoreApi } from "zustand";
import {
  ActionRadioField,
  AddEditItemObjectState,
  CommonFields,
  OnTaskSelect,
  TakeoffTaskBoundSelectField,
  TliData,
} from "./utils";

type LaborFieldsProps = {
  store: StoreApi<TakeoffsStoreState>;
  formState: ObjectState<AddEditItemObjectState>;
  planPackageId: string;
  initialTliData?: TliData;
  readOnly: boolean;
  takeoffRemovalsEnabled: boolean;
};

/** The labor line fields, apart from the modal chrome around them. */
export function LaborFields(props: LaborFieldsProps) {
  const { store, planPackageId, initialTliData, readOnly, formState, takeoffRemovalsEnabled } = props;
  const onTaskSelect: OnTaskSelect = useCallback(
    (id: string | undefined) => {
      formState.taskId.set(id);
    },
    [formState],
  );

  return (
    <>
      <ActionRadioField field={formState.action} readOnly={readOnly} takeoffRemovalsEnabled={takeoffRemovalsEnabled} />
      <TakeoffTaskBoundSelectField
        required
        selectedTask={initialTliData?.task}
        readOnly={readOnly}
        taskId={formState.taskId}
        onSelect={onTaskSelect}
      />
      <LocationPathField
        filter={{ rpav: [store.getState().planPackage.version.id] }}
        newLocationPathField={formState.newLocationPath}
        field={formState.locationId}
        onSelect={(_locationId, location) => formState.location.set(location)}
      />
      <CommonFields
        planPackageId={planPackageId}
        planPackageVersionId={store.getState().planPackage.version.id}
        readOnly={readOnly}
        formState={formState}
        takeoffRemovalsEnabled={takeoffRemovalsEnabled}
      />
    </>
  );
}
